import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddBillLayer from "../components/AddBillLayer";

const AddBillPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add Purchase Bill" />
        <AddBillLayer />
      </MasterLayout>
    </>
  );
};

export default AddBillPage;
